import React from 'react';
import NeoCenterListingTile from './NeoCenterListingTile';
import WithClickTracking from '../../components/WithClickTracking';
import CallToActionImageBlock from '../../../blocks/CallToActionImageBlock';
import { translateResourceString } from '../../../util/translationUtility';
import { pushGtmData } from "../../../util/gtm";

const NeoCenterListingWithClickTracking = WithClickTracking(NeoCenterListingTile);

export default ({ results, onResultClick, additionalBlocks, isFiltered }) => {
    return (
        <div className="press-release-list">

            {additionalBlocks && additionalBlocks.featured && !isFiltered &&
                <div className="post-teaser d-flex flex-row mb-4">
                    <a className="col-12 col-lg-8 post-teaser__image"
                        title={additionalBlocks.featured.title}
                        style={{ backgroundImage: "url(" + additionalBlocks.featured.image + ")" }}
                        href={additionalBlocks.featured.link}></a>
                    <div className="col-12 col-lg-4 post-teaser__body">
                        <div className="post-teaser__featured">
                            <h5 className="text-uppercase">{translateResourceString("/NeoCenter/ListingPage/Featured")}</h5>
                        </div>
                        <div className="post-teaser__header">
                            <a
                                className="post-teaser__title"
                                href={additionalBlocks.featured.link}>{additionalBlocks.featured.title}</a>
                            <div className="post-teaser__date">{additionalBlocks.featured.date}</div>
                        </div>
                        <div className="post-teaser__content">
                            <div dangerouslySetInnerHTML={{ __html: additionalBlocks.featured.description }} />
                        </div>
                        <a className="post-teaser__link" href={additionalBlocks.featured.link}
                            onClick={() => { pushGtmData(additionalBlocks.featured.linkGtmCategory, additionalBlocks.featured.linkGtmAction, additionalBlocks.featured.linkGtmLabel) }}>
                            {translateResourceString("/NeoCenter/ListingPage/FeaturedReadMore")}
                        </a>
                    </div>
                </div>
            }

            <div className="row">
                {results.map((product, i) => {
                    return (
                        <React.Fragment key={i}>
                            {i === 6 && additionalBlocks && additionalBlocks.callToAction &&
                                <CallToActionImageBlock {...additionalBlocks.callToAction} />
                            }

                            <NeoCenterListingWithClickTracking
                                {...product}
                                onResultClick={onResultClick}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};